import { globalApi as api } from '../../api';


export const fetchClient_unit_wise_holidaysData = async () => {
  try {
    const response = await api.get(`/get_branch_holidays`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const update_client_and_unit_wise_holiday = async (id, holidaysData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_client_and_unit_wise_holidays/${id}`, holidaysData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const deleteClient_unit_wise_holidays = async (id,deleteData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_client_and_unit_wise_holidays/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: deleteData
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const Client_unit_wise_holidaysUpload = async (holidaysDataInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const response = await api.post('/upload_client_and_unit_wise_holidays', holidaysDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       }
//     });
//     return {
//       data: response,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response.data.error;
//   }
// };


export const Client_unit_wise_holidaysUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_client_and_unit_wise_holidays', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};




export const multiDeleteClient_unit_wise_holidays = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/multiple_delete_client_and_unit_wise_holidays', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
